import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { AddIcon } from 'tdesign-icons-react';
import { Button, Link, MessagePlugin, Popconfirm, Space, Table } from 'tdesign-react';
import { connect } from 'react-redux';
import { deleteFlowGroup, getFlowGroupList, moveFlowGroup } from '@/services/templateService';
import useTable from '@/hooks/useTable';
import { setCurrentFlowGroups } from '@/slices/templateSlice';
import FormModal from './FormModal';

function NodeGroup({ setCurrentFlowGroups }) {
  const [visible, setVisible] = useState(false);
  const [searchParams] = useSearchParams();
  const [currentRow, setCurrentRow] = useState();

  const id = searchParams.get('id');

  const columns = [
    {
      title: '主机组名称',
      colKey: 'name',
    },
    {
      title: '主机组显示说明',
      colKey: 'explains',
      ellipsis: true,
    },
    {
      title: '备注',
      colKey: 'notes',
      ellipsis: true,
    },
    {
      colKey: 'option',
      title: '操作',
      fixed: 'right',
      align: 'center',
      cell: ({ row, rowIndex }) => (
        <Space>
          <Link theme='primary' onClick={() => toOrder(rowIndex, rowIndex - 1)} hover='color'>
            上移
          </Link>
          <Link theme='primary' onClick={() => toOrder(rowIndex, rowIndex + 1)} hover='color'>
            下移
          </Link>
          <Link theme='primary' onClick={() => doEdit(row)} hover='color'>
            修改
          </Link>
          <Popconfirm theme='danger' content='确定删除？' onConfirm={() => doDelete(row)}>
            <Link theme='danger' hover='color'>
              删除
            </Link>
          </Popconfirm>
        </Space>
      ),
      width: 220,
    },
  ];

  const toOrder = async (currentIndex, nextIndex) => {
    const array = data.slice();
    if (nextIndex > -1 && nextIndex < array.length) {
      [array[currentIndex], array[nextIndex]] = [array[nextIndex], array[currentIndex]];
    }
    const ids = array.map((item) => item.id);
    const tip = MessagePlugin.loading({
      content: '移动中...',
      duration: 0,
    });
    try {
      await moveFlowGroup({ ids });
      doRefresh();
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      MessagePlugin.close(tip);
    }
  };

  const doEdit = (row) => {
    setCurrentRow(row);
    setVisible(true);
  };

  const doDelete = async (row) => {
    await deleteFlowGroup(row.id);
    MessagePlugin.success('操作成功');
    doRefresh();
  };

  const loadData = useMemoizedFn(async () => {
    const { data } = await getFlowGroupList({ flowBaseId: id });
    setData(data);
    setCurrentFlowGroups(data);
  });

  const { header, config, setData, doSearch, doRefresh, data } = useTable({
    columns,
    search: <Title>主机组信息</Title>,
    searchButton: null,
    refresh: null,
    columnController: null,
    onSearch: loadData,
    operators: (
      <Button variant='outline' theme='primary' icon={<AddIcon />} onClick={() => setVisible(true)}>
        新建主机组
      </Button>
    ),
  });

  const handleClose = (refresh) => {
    setVisible(false);
    setCurrentRow(null);
    if (refresh) {
      doRefresh();
    }
  };

  useEffect(() => {
    doSearch();
  }, [doSearch]);

  return (
    <>
      {header}
      <Table {...config} />
      <FormModal detail={currentRow} visible={visible} handleClose={handleClose} />
    </>
  );
}

export default connect(null, {
  setCurrentFlowGroups,
})(NodeGroup);

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: var(--td-text-color-primary);
  padding-left: 8px;
  display: flex;
  align-items: center;
  height: 32px;
`;
